'use client';

import React from 'react';

/**
 * Hook that alerts hover outside of the passed ref
 */
export const useHoverOutside = (ref: React.MutableRefObject<HTMLElement | null>, callback: () => void): void => {
  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleHoverOutside(event: MouseEvent) {
      if (ref?.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    }

    // Bind the event listener
    document.addEventListener('mouseover', handleHoverOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mouseover', handleHoverOutside);
    };
  }, [callback, ref]);
};
